import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import { currentUserIsManager, setCookie, getCookie, isUnsupportedDevice, isUnsupportedBrowser } from '../../util';

import { getIcon, getBrowserIcon } from '../../util/icons';

class UnsupportedModal extends Component{

  state = {
    visible: false,
  }

  componentWillMount(){
    if(isUnsupportedBrowser() || isUnsupportedDevice()){
      if(getCookie('velocity_v0_unsupported_browser_dismissed') !== 'YES'){
        this.setState({
          visible: true
        });
      }
    }
  }

  dismiss(){
    setCookie('velocity_v0_unsupported_browser_dismissed', 'YES');

    this.setState({
      visible: false
    });
  }

  renderSupportedBrowsers(){
    return (
      <div className="modal-content">
        <div className="message-icon">{getIcon('info')}</div>
        <h2>Unsupported browser or device detected</h2>
        <p>In order to get the best experience with this Beta version of the app, we recommended using your <b>desktop or laptop computer</b> (the beta is not optimized for tablet or mobile devices), and using one of the <b>supported browsers</b> listed below.</p>
        <p>Click any of the supported browsers below to install, or if you're on your phone or tablet, go ahead and switch over to your laptop or desktop computer for now until we release the mobile & tablet friendly version of the app.</p>
          <div className="browsers">
            <div className="supported">
              <a href="https://google.com/chrome" target="_blank">
                {getBrowserIcon('chrome')}
              </a>
              <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">
                {getBrowserIcon('firefox')}
              </a>
              <a href="https://support.apple.com/downloads/safari" target="_blank">
                {getBrowserIcon('safari')}
              </a>
            </div>
            <div className="unsupported">
              {getBrowserIcon('edge')}
              {getBrowserIcon('ie')}
              {getBrowserIcon('opera')}
            </div>
          </div>
      </div>
    );
  }

  render(){

    const { currentStep, welcomeComplete } = this.state;

    if(!this.state.visible){
      return null;
    }

    return (
      <div className={`modal unsupported full-screen`}>
        <div
          className="modal-container"
          ref={elem => { this.container = elem; }}
        >
          {this.renderSupportedBrowsers()}
          <div className="modal-actions centered">
            <button onClick={this.dismiss.bind(this)} className="button grey-button">Continue Anyway</button>
          </div>
        </div>
      </div>
    )
  }
}

export default UnsupportedModal;



// WEBPACK FOOTER //
// ./src/components/modals/unsupported.js